import React, { useState } from 'react'
import { Grid, Typography, Card, CardContent } from '@mui/material'
import ReactPlayer from 'react-player'
import { useDropzone } from 'react-dropzone'
import { useFormikContext } from 'formik'
import MyButton from '../../../components/ui/MyButton'
import './ReactPlayer.css'
import VideoLabelIcon from '@mui/icons-material/VideoLabel'
import { Cloudinary } from '@cloudinary/url-gen'

const VideoUploader = () => {
  const [dataToPreview, setDataToPreview] = useState(null)

  const { setFieldValue, values } = useFormikContext()

  const cld = new Cloudinary({
    cloud: {
      cloudName: 'youspeak',
    },
  })

  let cldVideo = ''
  let cldThumbnail = ''
  if (values && values.video) {
    const cldRes = cld.video(values.video)

    cldVideo = cldRes.toURL()

    cldThumbnail = cldVideo.split('?')[0]
    cldThumbnail = cldThumbnail + '.jpg'
  }

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: 'video/*',
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0]
      previewFile(file)

      setFieldValue('selectedVideo', file)
    },
    noClick: true,
    noKeyboard: true,
  })

  const previewFile = (file) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      setDataToPreview(reader.result)
    }
  }

  return (
    <Card>
      <CardContent>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={1}
        >
          <Grid item>
            {' '}
            <Typography variant="h6" style={{ width: '100%' }}>
              Upload your introduction video{' '}
              <span style={{ color: 'red' }}>( * )</span>
            </Typography>
          </Grid>

          <Grid item>
            {' '}
            <Typography variant="body1">
              about 1 - 5 minutes of length
            </Typography>
          </Grid>

          <Grid item container justifyContent="center" alignItems="center" spacing={2}>
            <Grid item style={{ minWidth: '100%' }}>
              <div className="player-wrapper">
                <ReactPlayer
                  url={
                    dataToPreview
                      ? dataToPreview
                      : cldVideo
                      ? cldVideo
                      : ''
                  }
                  controls
                  width="100%"
                  height="100%"
                  className="react-player"
                  light={
                    cldThumbnail && !dataToPreview
                      ? cldThumbnail
                      : ''
                  }
                  playing={dataToPreview ? true : false}
                />
              </div>
            </Grid>

            <Grid item>
              <section>
                <div
                  style={{
                    width: '100%',
                    border: '1px dashed lightgray',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '1em',
                  }}
                  {...getRootProps({ className: 'dropzone' })}
                >
                  <input {...getInputProps()} />

                  <Grid
                    container
                    direction="column"
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid item>
                      <VideoLabelIcon style={{ fontSize: '2rem' }} />
                    </Grid>

                    <Grid item>
                      <Typography variant="body2">
                        Drag 'n' drop a file here, or click to select your file
                      </Typography>
                    </Grid>

                    <Grid item>
                      <MyButton onClick={open}>Select your file</MyButton>
                    </Grid>
                  </Grid>
                </div>
              </section>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default VideoUploader
